(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/init.js');

'use strict';

var logger = svs.core.log.getLogger('component:youtube-video_init');
var trackEvent = svs.components.analytics.trackEvent;
var isSafari = svs.core.detect.browser.safari();

function youtubeIframe(el, src, id) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute('class', "js-youtube-video-".concat(id, " js-youtube-video-iframe youtube-video-iframe"));
  iframe.setAttribute('id', "js-youtube-video-".concat(id));
  iframe.setAttribute('data-videoid', id);
  iframe.setAttribute('src', "".concat(src, "&").concat(isSafari ? 'autoplay=1&mute=1' : 'autoplay=1', "&origin=").concat(window.location.origin));
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  el.style.display = 'none';
  el.closest('div.js-youtube-video-container').append(iframe, el);
}

svs.components.youtube_video.renderYoutubePlayer = function (event, videoSrc, videoId, videoTitle) {
  var element = event.target;
  var videoLabel = videoTitle ? "".concat(videoId, "-").concat(videoTitle) : "".concat(videoId);
  trackEvent({
    action: 'Start',
    category: 'Video',
    opt_label: videoLabel,
    opt_value: 1
  });
  youtubeIframe(element, videoSrc, videoId);
};

svs.components.youtube_video.init = function (options) {
  if (!options.videoId) {
    logger.error('Missing videoId');
    return;
  }
  if (options && options.selector && options.src) {
    var videoHtml = svs.components.youtube_video.templates.youtube_video(options);
    $(options.selector).append(videoHtml);
  } else {
    logger.error('Error in options object', options);
  }
};

function setFocusOnTab() {
  document.addEventListener('keydown', function (e) {
    var activeElement = document.activeElement;
    if (e.key === 'Tab') {
      var focusOutline = document.querySelector('.svs-keyboard-yt-focus');
      if (focusOutline) {
        focusOutline.classList.remove('svs-keyboard-yt-focus');
      }
      setTimeout(function () {
        activeElement = document.activeElement;
        if (activeElement && activeElement.classList.contains('js-youtube-video-player')) {
          var parentVideoContainer = activeElement.parentElement.parentElement;
          if (parentVideoContainer) {
            parentVideoContainer.classList.add('svs-keyboard-yt-focus');
          }
        }
      }, 50);
    } else if (e.key === 'Enter') {
      if (activeElement && activeElement.classList.contains('js-youtube-video-player')) {
        activeElement.click();
      }
    }
  });

  document.addEventListener('mousedown', function () {
    var focusOutline = document.querySelector('.svs-keyboard-yt-focus');
    if (focusOutline) {
      focusOutline.classList.remove('svs-keyboard-yt-focus');
    }
  });

  document.addEventListener('blur', function () {
    var focusOutline = document.querySelector('.svs-keyboard-yt-focus');
    if (focusOutline) {
      focusOutline.classList.remove('svs-keyboard-yt-focus');
    }
  });
}

if (svs.core.detect.formfactor.desktop()) {
  setFocusOnTab();
}

document.addEventListener('DOMContentLoaded', function () {
  var imageElements = document.querySelectorAll('.js-youtube-video-thumbnail');
  imageElements.forEach(function (element) {
    if (element.naturalWidth === 120 && element.naturalHeight === 90) {
      var fallbackImage = element.cloneNode(true);
      element.parentElement.style.display = 'none';
      element.parentElement.parentElement.prepend(fallbackImage);
    }
  });
});

 })(window);